import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaTimes } from 'react-icons/fa';

const SuggestionPills = ({ onSuggestionClick }) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);
  
  const suggestions = [
    t('chat.suggestions.selfie'),
    t('chat.suggestions.addTodo'),
    t('chat.suggestions.summarizeWebsite')
  ];

  if (!isVisible) {
    return null;
  }

  return (
    <div className="relative mb-4">
      <div className="flex flex-wrap gap-2">
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            onClick={() => onSuggestionClick(suggestion)}
            className="bg-gray-800 hover:bg-gray-700 border border-gray-600 hover:border-gray-500 text-white px-4 py-2 rounded-full text-sm transition-colors duration-200 flex items-center"
          >
            <span className="mr-2">💬</span>
            {suggestion}
          </button>
        ))}
        <button
          onClick={() => setIsVisible(false)}
          className="bg-gray-800 hover:bg-gray-700 border border-gray-600 hover:border-gray-500 text-white px-3 py-2 rounded-full text-sm transition-colors duration-200 flex items-center justify-center"
          title="Close suggestions"
        >
          <FaTimes className="text-xs" />
        </button>
      </div>
    </div>
  );
};

export default SuggestionPills;